import { useEffect } from 'react'
import { useBucket } from '@mc/experiments-react'
import { trackSignedIn, trackSignedUp } from '../events'
import {
  hasAuthAttemptFlag,
  getLastLoginMethod,
  updateLastLoginMethod,
  clearAuthAttemptFlag,
} from '../utils/lastLoginMethod'

interface UseLoginSuccessDetectionOptions {
  isAuthenticated: boolean
  currentAuthType?: string
}

export const useLoginSuccessDetection = ({
  isAuthenticated,
  currentAuthType,
}: UseLoginSuccessDetectionOptions) => {
  const bucket = useBucket('post-pw-ce-3448-last-login-reminder')
  const isExperimentParticipant = !!bucket

  useEffect(() => {
    if (!isExperimentParticipant) {
      return
    }

    if (isAuthenticated) {
      const hasLoginAttempt = hasAuthAttemptFlag('login')
      const hasSignupAttempt = hasAuthAttemptFlag('signup')
      const lastLoginMethod = getLastLoginMethod()
      const promotedMethod = updateLastLoginMethod(currentAuthType)

      if (promotedMethod) {
        if (hasSignupAttempt) {
          trackSignedUp({
            loginMethod: promotedMethod,
            lastLoginMethod,
          })
        } else if (hasLoginAttempt) {
          trackSignedIn({
            loginMethod: promotedMethod,
            lastLoginMethod,
          })
        }
      }

      clearAuthAttemptFlag()
    }
  }, [isAuthenticated, currentAuthType, isExperimentParticipant])
}
